module.exports = __webpack_public_path__ + "static/media/005 color panel.73cba6d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/redboxinstant/005 color panel.png
// module id = 612
// module chunks = 0